import React from 'react'
import { Developers } from '../components/Developers'

export const About = () => {
  return (
    <div>
      <Developers/>
    </div>
  )
}
